module.exports = __webpack_public_path__ + "static/media/18_A.bc931e73.png";